import React from "react";
import classNames from "classnames/bind";
import {
  Button,
  ButtonGroup,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { canUseDOM } from "fbjs/lib/ExecutionEnvironment";

import LinkComponent from "~/components/LinkComponent";
import assetPath from "~/utils/assetPath";
import { getCookie } from "~/utils/cookie";
import {
  scaledDimension
} from "./utils";
import {
  isDesktopApp
} from "~/utils/misc";

export function canvasContainer() {
  return (
    <div id="canvas_container">
      <canvas id="canvas"></canvas>
      <canvas className="hide" id="image"></canvas>
      <canvas className="hide" id="image-preview"></canvas>
    </div>
  );
}

export function gameContainer(picture, offsetRight) {
  const dimensions = scaledDimension(picture, offsetRight);
  let height = dimensions.height;
  let width = dimensions.width;
  if (dimensions.width < dimensions.height && dimensions.height < window.innerWidth) width = window.innerWidth - 32 - offsetRight;
  let top = (window.innerHeight - height - (isDesktopApp() ? 0 : 48)) / 2;
  let left = (window.innerWidth - width) / 2;

  return (
    <div
      id="game_container"
      style={{
        width: `${width}px`,
        height: `${height}px`,
        top: `${top}px`,
        left: `${left - (offsetRight / 2)}px`
      }}
    >
      <img
        className="main lazyload"
        data-src={is.existy(picture.urls) ? picture.urls.full : ''}
      />
      <div className="shadow_overlay">
        <div className="overlay">
          <div className="section">
            <p>Amount of pieces:</p>
            <ButtonGroup className={classNames("amount_of_pieces_group", { active: is.not.inArray(getCookie("settingsAmountOfPieces", 100), [50, 100, 200, 400]) })}>
              <Button color="light" onClick={() => this.handleAmountOfPiecesTap(50)} active={is.equal(getCookie("settingsAmountOfPieces", 100), 50)}>50</Button>
              <Button color="light" onClick={() => this.handleAmountOfPiecesTap(100)} active={is.equal(getCookie("settingsAmountOfPieces", 100), 100)}>100</Button>
              <Button color="light" onClick={() => this.handleAmountOfPiecesTap(200)} active={is.equal(getCookie("settingsAmountOfPieces", 100), 200)}>200</Button>
              <Button color="light" onClick={() => this.handleAmountOfPiecesTap(400)} active={is.equal(getCookie("settingsAmountOfPieces", 100), 400)}>400</Button>
              <ButtonDropdown isOpen={this.state.amountOfPiecesDropdownOpen} toggle={this.handleAmountOfPiecesDropdownTap}>
                <DropdownToggle color="light" caret>
                  {`Other${is.not.inArray(getCookie("settingsAmountOfPieces", 100), [50, 100, 200, 400]) ? ` (${getCookie("settingsAmountOfPieces", 100)})` : ``}`}
                </DropdownToggle>
                <DropdownMenu>
                  <For each="amount" index="idx" of={[10,20,40,80,160,320,640]}>
                    <DropdownItem key={idx} onClick={() => this.handleAmountOfPiecesTap(amount)} active={is.equal(getCookie("settingsAmountOfPieces", 100), amount)}>{amount}</DropdownItem>
                  </For>
                </DropdownMenu>
              </ButtonDropdown>
            </ButtonGroup>
          </div>
          <div className="section">
            <p>Rotate pieces:</p>
            <ButtonGroup>
              <Button
                color="light"
                onClick={() => this.handleRotatePiecesTap(false)}
                active={is.falsy(getCookie("settingsRotatePieces", false))}
              >
                Off
              </Button>
              <Button
                color="light"
                onClick={() => this.handleRotatePiecesTap(true)}
                active={is.truthy(getCookie("settingsRotatePieces", false))}
              >
                On
              </Button>
            </ButtonGroup>
          </div>
          <Button
            className="start_game_button"
            onClick={this.handleStartGameTapped}
          >
            <img alt="Start puzzle" src={assetPath("play_large", "png")} />
            <span>Start puzzle</span>
          </Button>
        </div>
        <span className="credit_overlay">Photo by <a href={`${picture.user.links.html}?utm_source=Online%20Jigsaw%20Puzzles&utm_medium=referral`} target="_blank">{picture.user.name}</a> on <a href="https://unsplash.com/" target="_blank">Unsplash</a></span>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/puzzles/components/PuzzleComponent/helpers/elements.js